<template>
  <el-dialog
    v-loading="loading"
    :visible.sync="visible"
    :append-to-body="true"
    :close-on-click-modal="true"
    title="ویرایش شارژ اکانت"
    width="580px"
  >
    <el-form @submit.native.prevent="submit">
      <el-row :gutter="10">
        <el-col :span="12" :xs="12" class="mb-4">
          <label class="font-9"> شارژ اکانت (تومان): </label>
          <currency-input
            key="editing-credit"
            v-model="form.amount"
            v-validate="'required|numeric|min_value:1'"
            size="small"
            style="width: 100%"
            placeholder="مبلغ"
            data-vv-as="مبلغ"
          />
          <div style="clear: both"></div>
        </el-col>
        <el-col :span="12" :xs="12" class="mb-4">
          <div style="float: left">
            <span>افرایش</span>
            <el-switch
              v-model="isIncreasing"
              style="margin: 0 1rem"
              active-color="#49d62d"
              inactive-color="rgb(243, 32, 19)"
            >
            </el-switch>
            <span>کاهش</span>
          </div>

          <div style="clear: both"></div>
        </el-col>
        <el-col :sm="24" class="mb-3">
          <label class="font-9 required">توضیحات</label>
          <el-input
            ref="name"
            key="field-name"
            v-model="form.description"
            v-validate="'required'"
            type="textarea"
            data-vv-as="توضیحات"
            placeholder="توضیحات"
          />
        </el-col>
      </el-row>
      <div class="text-center" style="margin:20px 0 -10px">
        <el-button type="primary" native-type="submit" :loading="loading">
          ثبت
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import UpdateCreditQuery from '@/graphql/user/UpdateCredit.gql'

import CurrencyInput from '@/components/CurrencyInput.vue'

import { FormMixin } from '@/modules/mixins'

export default {
  name: 'UserForm',
  components: {
    CurrencyInput
  },
  mixins: [FormMixin],
  props: {
    editingId: { type: [String, Number, Boolean], default: '' },
    editingItem: { type: Object, default: null },
    show: { type: Boolean, default: false },
    user: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      loading: false,
      form: {},
      isIncreasing: true
    }
  },
  computed: {
    editing() {
      if (this.editingId) return this.editingId
      if (this.editingItem) return this.editingItem.id
      return false
    },
    visible: {
      get() {
        return this.show
      },
      set(val) {
        return this.$emit('update:show', !!val)
      }
    },
    coefficient() {
      return this.isIncreasing ? 1 : -1
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val == true) {
          this.form = this.createCreditForm()
        }
      }
    }
  },
  methods: {
    createCreditForm() {
      return {
        amount: 0,
        description: ''
      }
    },
    submit() {
      this.$validate().then(() => {
        this.apollo
          .mutate({
            query: UpdateCreditQuery,
            variables: {
              userId: this.user.id,
              description: this.form.description,
              amount: this.form.amount * this.coefficient * 10
            },
            $loadingKey: 'loading'
          })
          .then(() => {
            this.$message.success('اطلاعات با موفقیت ثبت شد')
            this.visible = false
            this.$emit('updateTable')
          })
      })
    }
  }
}
</script>
